export default __webpack_public_path__ + "static/media/48.a01faff1.png";